export const FactsetIds = {
  countries: {
    USA: 244,
  },
  news: {
    categories: {
      equity: 83012,
      bond: 79045,
    },
    distrbutorIds: {
      default: 2511684,
    },
  },
  markets: {
    NYSE: "42",
    AMEX: "46",
    Nasdaq: "78",
  },
  indexes: [
    "8354115", // NYSE Composite Index
    "1324741", // NYSE MKT Composite Index
    "1047705", // Dow Jones US Utilities
    "324980", // Dow Jones Transportation Average
    "324977", // Dow Jones Industrial Average
    "324985", // NASDAQ Composite Index
    "8941848", // S&P 500 Index
    "11416586", // CBOE Intrest Rate 10 Year T-Bond Note
  ],
} as const;
